import { Button, Grid } from "@mui/material";
import { OperacaoEdicaoDelivery } from "./containers/OperacaoEdicaoDelivery";
import { OperacaoEdicaoRetirada } from "./containers/OperacaoEdicaoRetirada";
import { OperacaoEdicaoMesa } from "./containers/OperacaoEdicaoMesa";
import { HeaderGrid, OperacaoContainer } from "./styles";
import { useTamanhoTela } from "../../../core/hooks/useTamanhoTela";
import { OperacaoEdicaoSimples } from "./containers/OperacaoEdicaoSimples";
import { useConfiguracoesPedidoContext } from "../../contexts/ConfiguracoesPedidoContext";
import { useOperacaoEdicaoContext } from "../../contexts/OperacaoEdicaoContext";
import FullScreenLoading from "../../../core/components/FullScreenLoading";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";

export function OperacaoEdicao() {
    const { pedido, loading } = useOperacaoEdicaoContext();

    const renderizarComponentePorTipo = (tipo: string) => {
        switch (tipo) {
            case 'delivery':
                return <OperacaoEdicaoDelivery />;
            case 'retirada':
                return <OperacaoEdicaoRetirada />;
            case 'mesa':
                return <OperacaoEdicaoMesa />;
            case 'simples':
                return <OperacaoEdicaoSimples />;
            default:
                return <div>Componente não encontrado para o tipo {tipo}</div>;
        }
    };

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleVoltar = () => {
        const redirect = searchParams.get("redirect");
        if (redirect) {
            navigate(redirect);
        } else {
            navigate("/pedidos/listagem");
        }
    };

    return (
        <OperacaoContainer>
            {loading ? <FullScreenLoading /> : ''}
            <Grid
                container
                spacing={0}
                sx={{ width: "100%" }}
            >
                <HeaderGrid item xs={12} sx={{ padding: "0 1rem" }}>
                    <Button startIcon={<ChevronLeft />} onClick={handleVoltar}>
                        Voltar
                    </Button>
                </HeaderGrid>
                <Grid item xs={12}>
                    {pedido && renderizarComponentePorTipo(pedido.tipo)}
                </Grid>
            </Grid>
        </OperacaoContainer>
    );


}